import { Grid, useMediaQuery } from '@mui/material';

import WebView from './WebView/WebView';
import MobileView from './MobilView/MobileView';

const Escalation = () => {
    const isSmallScreen = useMediaQuery('(max-width:960px)')

  return (
    <Grid >
        { isSmallScreen ? <MobileView />  :<WebView />}
    </Grid>
  )
}

export default Escalation
